export enum Features{
    PARTICIPANTS="Participants",
    TEMPLATE="Template",
    MEETINGS="Meeting",
    UPCOMINGMEETINGS="UpcomingMeetings",
    PASTMEETINGS="PastMeetings",
    PENDINGTASK="PendingTask",
    COMPLETEDTASK="CompletedTask",
    COPYMEETING="CopyMeeting",
    POSTPONEMEETING="PostponeMeeting",
    TASK="Task",
    MOMCOMPLETE="MOM Complete",
    MOMAPPROVE="MOM Approve",
    ENDMEETING="End Meeting",
    CANCALMEETING="CancelMeeting",
    SEARCH="Search",
    INSTANTMEETING="InstantMeeting",
    AGENDA="Agenda",
    MINUTES="Minutes",
    NOTES="Notes",
    PHEMEREPORT="PhemeReport",
    PHEME="Pheme"
}
